import styles from './DeleteButton.module.css';

function DeleteButton({ onClick, disabled }) {
  return (
    <button className={styles.deleteButton} onClick={onClick} disabled={disabled}>
      Delete
    </button>
  );
}

export default DeleteButton;